import styled, { css } from 'styled-components';
import { TypographyVariant } from '../../../utils/theme';
import Typography from '../../typography/typography';

interface NotificationProps {
  count?: number;
  isDotNotification: boolean;
}

const Notification = ({ count, isDotNotification }: NotificationProps) => {
  if (!count) return;

  if (isDotNotification) {
    return (
      <DotNotification
        role="img"
        aria-label={`tab-notification-${count}`}
        aria-hidden
      />
    );
  }

  return (
    <NotificationCount variant={TypographyVariant.labelSm} aria-hidden>
      {count}
    </NotificationCount>
  );
};

export default Notification;

const DotNotification = styled.div`
  ${({ theme }) => css`
    width: 6px;
    height: 6px;
    background-color: ${theme.palette.error.main};
    border-radius: 50%;
  `};
`;

const NotificationCount = styled(Typography)`
  ${({ theme }) => css`
    background: ${theme.palette.error.main};
    border-radius: 2px;
    padding: ${theme.spacing(0.5)};
    min-width: 17px;
    text-align: center;
    color: ${theme.palette.neutral['00']};
  `}
`;
